import { render, staticRenderFns } from "./ProductAttributeForm.vue?vue&type=template&id=4dcea7e3&"
import script from "./ProductAttributeForm.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports